// companyEmployeeCoverageService.ts — Zusatzfelder der Mitarbeiter-Tabelle
// „Menschen im Unternehmen" (ContactDetails, Firma): Abteilung + Absicherungs-
// Marker (bAV/bKV/UV/Betriebshaftpflicht) je (Firma, Person).
// Die Personenliste selbst kommt aus den Relationen des Kontakt-Detail-Loads.

import { apiFetch } from "../utils/apiFetch";

export type EmployeeCoverageRow = {
  personContactId: number;
  department: string | null;
  bav: boolean;
  bkv: boolean;
  uv: boolean;
  betriebshaftpflicht: boolean;
};

export async function listEmployeeCoverage(
  companyId: number,
  signal?: AbortSignal,
): Promise<EmployeeCoverageRow[]> {
  const { data } = await apiFetch<EmployeeCoverageRow[]>(
    `company-employee-coverage/${companyId}`,
    { signal },
  );
  return Array.isArray(data) ? data : [];
}

/** Vollzeilen-Upsert — idempotent; Content-Type ist Pflicht (sonst leerer @Body). */
export async function saveEmployeeCoverage(
  companyId: number,
  row: EmployeeCoverageRow,
): Promise<void> {
  await apiFetch(`company-employee-coverage/${companyId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(row),
  });
}
